import {Pipe, PipeTransform} from '@angular/core';

@Pipe ({
  name: 'statusmap'
})
export class StatusMapperPipe implements PipeTransform {
  transform(value: any, limit?: number) {
    if (value != null && value.toString().toUpperCase() === 'A') {
      return 'Coming';
    }
    if (value != null && value.toString().toUpperCase() === 'A') {
      return 'Coming';
    }
    if (value != null && value.toString().toUpperCase() === 'W') {
      return 'Waiting';
    }
    if (value != null && value.toString().toUpperCase() === 'N') {
      return 'No';
    }
    if (value != null && value.toString().toUpperCase() === 'I') {
      return 'Not decided';
    }
    return value;
  }
}
